import {saveLocal} from '@/assets/js/common'
import $api from '@/assets/js/ajax'
// 基本模块
const baseModule = {
  state: {
    token: '',
    userInfo: null,
    uploadSys: '', // 上传下载key
    uploadTime: 0
  },
  mutations: {
    setToken: (state, data) => {
      state.token = data
    },
    removeToken: (state) => {
      state.token = null
      saveLocal('userToken', 'token', null)
    },
    setUserInfo: (state, data) => {
      state.userInfo = data
    },
    setUploadSys: (state, data) => {
      state.uploadSys = data
      state.uploadTime = Date.now()
    }
  },
  actions: {
    getUserInfo: ({commit}) => {
      return new Promise(resolve => {
        $api.loginInfo(res => {
          commit('setUserInfo', res)
          resolve(res)
        })
      })
    },
    getUploadInfo: ({commit}) => {
      $api.getUploadInfo((res) => {
        commit('setUploadSys', res)
      })
    }
  }
}

export default baseModule



// WEBPACK FOOTER //
// ./src/store/base.js